"use strict";
/** Κοινό λεξιλόγιο UI για web & mobile — απλή 3-βηματική ροή προσφοράς. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SIMPLE_COPY = void 0;
exports.SIMPLE_COPY = {
    captureCta: 'Γρήγορη προσφορά',
    captureCtaShort: '+ Γρήγορη προσφορά',
    speakCta: 'Μίλησε',
    siteNotesTitle: 'Σημειώσεις επίσκεψης',
    buildOfferCta: 'Φτιάξε την προσφορά',
    advancedCreateLink: 'Προχωρημένη',
    /** Σύνδεσμος προς πλήρη φόρμα προσφοράς (π.χ. από Ρυθμίσεις). */
    advancedCreateOfferLink: 'Προχωρημένη προσφοράς',
    advancedCreateTitle: 'Προχωρημένη',
    advancedSectionTitle: 'Για προχωρημένους',
    capturePageTitle: 'Γρήγορη προσφορά',
    captureStepNotes: 'Τι χρειάζεται ο πελάτης',
    captureStepCustomer: 'Ποιος είναι ο πελάτης',
    captureStepFinish: 'Φτιάξε την προσφορά',
    addNoteLine: 'Πρόσθεσε γραμμή',
    newCustomer: 'Νέος πελάτης',
    selectCustomer: 'Επίλεξε πελάτη',
    captureAmountLabel: 'Ποσό (€)',
    captureAmountHint: 'προαιρετικό — εμφανίζεται στην προσφορά',
    homeCaptureTitle: 'Γρήγορη προσφορά',
    homeCaptureDescription: 'Τρία απλά βήματα: τι χρειάζεται ο πελάτης, ποιος είναι, και η AI φτιάχνει την προσφορά. Με φωνή ή κείμενο.',
    homeAdvancedTitle: 'Προχωρημένη δημιουργία',
    homeAdvancedDescription: 'Πλήρης φόρμα για τίτλο, ποσό, επεξεργασία κειμένου, φωτογραφία σημειώσεων και εξαγωγή PDF.',
    homeNewCustomerTitle: 'Νέος πελάτης',
    homeNewCustomerDescription: 'Καταχώρησε επαφή με στοιχεία επικοινωνίας, στάδιο στο CRM και tags για μελλοντικές προσφορές.',
    homeNewTaskTitle: 'Νέα εργασία',
    homeNewTaskDescription: 'Υπενθύμιση ή εργασία για πελάτη: τίτλος, προθεσμία και σύνδεση με τον CRM ώστε να μην ξεχνάς τίποτα.',
    homeNewExpenseTitle: 'Νέο έξοδο',
    homeNewExpenseDescription: 'Καταχώρησε απόδειξη με φωτογραφία ή χειροκίνητα: ποσό, ημερομηνία και σύνδεση με έργο ή προσφορά.',
    homeNewProjectTitle: 'Νέο έργο',
    homeNewProjectDescription: 'Δημιούργησε έργο με τίτλο και περιγραφή· σύνδεσε προσφορές, έξοδα και φωτογραφίες στο portfolio σου.',
};
